/** Dev-only markers for JiT cache / prefetch / playback (filter console by `jit-audio`). */
export const jitAudioLog = (...args: unknown[]) => {
  if (import.meta.env.DEV) {
    console.log('[jit-audio]', ...args);
  }
};
